import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { useRouteMatch, Link } from 'react-router-dom';
import Modal from '../../components/Modal';
import AddOrEditCategory from '../add-or-edit-category';
import { Trans } from 'react-i18next';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Category: FC<any> = ({ data }) => {
  const { name, isDeleted, imagePath, note, id } = data;
  const match = useRouteMatch();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState();

  function openModal() {
    setIsOpen(true);
    setModalData(data);
  }

  function closeModal() {
    setIsOpen(false);
    setModalData(undefined);
  }

  return (
    <>
      <Modal open={modalIsOpen} closeModal={closeModal}>
        <AddOrEditCategory data={modalData} close={closeModal} />
      </Modal>

      <tr>
        <td>{name}</td>
        <td>{note}</td>
        <td>{imagePath}</td>
        <td>
          <label className={`badge badge-${isDeleted ? 'danger' : 'success'}`}>
            {isDeleted ? 'Deleted' : 'Active'}
          </label>
        </td>
        <td>
          <Link
            className="btn btn-outline-dark btn-fw btn-sm"
            to={`${match.url}/${id}/sub-categories`}
          >
            <span className="menu-title">
              <Trans>View</Trans>
            </span>
          </Link>
          <button className="btn btn-dark btn-fw btn-sm" onClick={openModal}>
            edit
          </button>
        </td>
      </tr>
    </>
  );
};

export default Category;
